<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title38"></a>
<div class="p-c-br"><span><em class="i">This novel is dedicated to my sister, Jamie,<br/> with love, faith, and blessings</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429905916_ded01.vue?5b72783e